
interface EventDescriptionProps {
  description?: string;
  showInCard?: boolean;
}

export const EventDescription = ({ description, showInCard = true }: EventDescriptionProps) => {
  if (!description || !showInCard) return null;
  
  return (
    <p className="text-sm text-gray-600 mb-3">{description}</p>
  );
};
